module.exports = __webpack_public_path__ + "img/scjr-tzr.60759907.jpg";